import userProfileLinkSelector from 'root/src/client/logic/creatorData/selectors/userProfileLinkSelector'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default () => async (dispatch, getState) => {
	const state = getState()
	const { routeId, recordId } = userProfileLinkSelector(state)
	return pushRouteClient({ routeId, routeParams: { recordId } })
}
